const strize = require('../strize')

module.exports = {
  title: 'PP ADMIN',
  imgs: {
    root: '../../imagesPP'
  },
  home: '/simuplayers',
  features: {
    elearning: false,
    simu: true,
    eval: true
  },
  bucket: {
    player: {
      bucket: 'tgd2editor-test',
      region: 'eu-west-3',
    },
    editor: {
      bucket: 'tgd2editor-test',
      region: 'eu-west-3',
      key: strize(''),
      secret: strize('')
    }
  },
  colors: {
    main: '#000000',
    bgSideBar: '#024179',
    ActionMail:'#dadada'
  },
  layouts: {
  }
}
